/* import __COLOCATED_TEMPLATE__ from './eye.hbs.js'; */
import Component from '@glimmer/component';
export default class Eye extends Component {
  get width() {
    return this.args.width ?? 20;
  }
  get height() {
    return this.args.height ?? 14;
  }
  get viewBox() {
    return this.args.viewBox ?? '0 0 20 14';
  }
  get fill() {
    return this.args.fill ?? 'black';
  }
  get fillOpacity() {
    return this.args.fillOpacity ?? 1;
  }
}